import React, { memo, ReactNode, useCallback } from 'react';
import RcModal from 'react-modal';
import cx from 'clsx';

import { IconRcCloseModal } from '@/assets/common';

import style from './index.module.scss';

export type CommonModalProps = {
  on?: boolean;
  turnOff?(): void;
  children?: ReactNode;
  className?: string;
  shouldCloseOnOverlayClick?: boolean;
  containerClassName?: string;
  hideCloseBtn?: boolean;
};

const _CommonModal = ({
  on = true,
  shouldCloseOnOverlayClick = true,
  turnOff,
  children,
  className,
  containerClassName,
  hideCloseBtn,
}: CommonModalProps) => {
  const handleCloseClick = useCallback(
    (e: React.MouseEvent<SVGElement>) => {
      e?.stopPropagation();
      turnOff?.();
    },
    [turnOff],
  );

  return (
    <RcModal
      className={cx(style.commonModal, className)}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      isOpen={on}
      shouldFocusAfterRender={false}
      onRequestClose={handleCloseClick}
      overlayClassName={style.overlay}
      ariaHideApp={false}>
      <div className={cx(style.container, containerClassName)}>{children}</div>
      {hideCloseBtn ? null : (
        <div className={style.bottomWrapper}>
          <IconRcCloseModal className={style.closeIcon} onClick={handleCloseClick} />
        </div>
      )}
    </RcModal>
  );
};

export const CommonModal = memo(_CommonModal);
